import { createContext, useContext, useEffect } from 'react';

export type MobileFilterSheetApi = {
  openFilters: () => void;
  closeFilters: () => void;
  filtersOpen: boolean;
  /** Discrete filter facets currently applied (drives the mobile FAB badge). */
  activeFilterCount: number;
  setActiveFilterCount: (count: number) => void;
};

export const MobileFilterSheetContext = createContext<MobileFilterSheetApi | null>(null);

/**
 * True only for sidebar content rendered inside the mobile filter sheet.
 * Desktop (and inline mobile filters) keep the elevated panel.
 */
export const FilterSheetChromeContext = createContext(false);

export function useInFilterSheet(): boolean {
  return useContext(FilterSheetChromeContext);
}

/** Non-null inside `MobileSidebarHost` on narrow viewports — used to drive a top toolbar filter trigger. */
export function useMobileFilterSheet(): MobileFilterSheetApi | null {
  return useContext(MobileFilterSheetContext);
}

/**
 * Report how many filters are applied so the mobile tune FAB can show a badge.
 * No-op on desktop (context is null). Resets to 0 on unmount.
 */
export function useReportMobileFilterCount(count: number): void {
  const api = useMobileFilterSheet();
  const setActiveFilterCount = api?.setActiveFilterCount;

  useEffect(() => {
    if (!setActiveFilterCount) return;
    setActiveFilterCount(count);
    return () => setActiveFilterCount(0);
  }, [count, setActiveFilterCount]);
}
